module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/UY-d76985fa9c7d1ba1751e9b7914f4ff05.png";